import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStaticState } from '@phishtool/ui';
import { StyledItem, StyledItemDescription, StyledItemHeading, StyledItemHeadingNote, StyledLogo, StyledTrack, StyledViewport, } from './styled';
import { useCarousel } from './use-carousel';
// The wordmark is the only thing naming the category, so it needs an accessible name.
// Spelled as the artwork reads — the ids are only sprite filenames.
const logoLabels = {
    'fortune-500': 'Fortune 500',
    'managed-service-providers': 'Managed Service Providers',
    'cybersecurity-vendors': 'Cybersecurity Vendors',
    'professional-services': 'Professional Services',
    'government-and-defense': 'Government & Defence',
    'technology-sector': 'Technology Sector',
    'pharmaceuticals-and-life-sciences': 'Pharmaceuticals & Life Sciences',
    'aerospace-and-defense': 'Aerospace & Defence',
    'legal-services': 'Legal Services',
    'critical-infrastructure': 'Critical Infrastructure',
    'financial-services': 'Financial Services',
    'energy-and-utilities': 'Energy & Utilities',
    telecommunications: 'Telecommunications',
    'public-sector': 'Public Sector',
    'higher-education': 'Higher Education',
};
const Logo = ({ logo }) => {
    var _a;
    const [staticData] = useStaticState();
    const src = (_a = staticData === null || staticData === void 0 ? void 0 : staticData.manifest) === null || _a === void 0 ? void 0 : _a['assets/logo-sprite.svg'];
    return (_jsx(StyledLogo, { role: "img", "aria-label": logoLabels[logo], "data-testid": `${logo}-logo`, children: _jsx("use", { href: `${src}#${logo}` }) }));
};
const Item = ({ item, isClone }) => (_jsxs(StyledItem, { "aria-hidden": isClone, children: [_jsxs(StyledItemHeading, { children: [item.heading, !!item.headingNote && _jsx(StyledItemHeadingNote, { children: item.headingNote })] }), _jsx(Logo, { logo: item.logo }), _jsx(StyledItemDescription, { children: item.description })] }));
const SocialProofCarousel = ({ title, items }) => {
    const { canScroll, offset, isAnimated, pause, resume } = useCarousel({ itemCount: items.length });
    // A second copy fills the gap past the end of the list; index === items.length is
    // pixel-identical to index === 0, which is what makes the wrap invisible
    const trackItems = canScroll ? [...items, ...items] : items;
    return (_jsx(StyledViewport, { role: "region", "aria-roledescription": "carousel", "aria-label": title, onMouseEnter: pause, onMouseLeave: resume, onFocusCapture: pause, onBlurCapture: resume, children: _jsx(StyledTrack, { "$offset": offset, "$isAnimated": isAnimated, "$itemCount": items.length, "data-testid": "social-proof-track", children: trackItems.map((item, index) => {
                const isClone = index >= items.length;
                return _jsx(Item, { item: item, isClone: isClone }, isClone ? `${item.id}-clone` : item.id);
            }) }) }));
};
export default SocialProofCarousel;
